import React from "react";

import Header from "@cloudscape-design/components/header";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Tabs from "@cloudscape-design/components/tabs";

import VipFreespinsRules from "./VipFreespinsRules";
import VipFreespinsLogs from "./VipFreespinsLogs";
import VipFreespinsAnalytics from "./VipFreespinsAnalytics";

class VipFreespins extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			activeTab: "rules",
		};
	}

	render() {
		const commonProps = {
			Interface: this.props.Interface,
			doRoute: this.props.doRoute,
			styles: this.props.styles,
		};

		return (
			<SpaceBetween direction="vertical" size="m">
				<Header variant="h1" description="Manage VIP FreeSpins rules, logs and analytics">
					VIP FreeSpins
				</Header>

				<Tabs
					activeTabId={this.state.activeTab}
					onChange={({ detail }) => this.setState({ activeTab: detail.activeTabId })}
					tabs={[
						{
							id: "rules",
							label: "Rules",
							content: <VipFreespinsRules {...commonProps} />,
						},
						{
							id: "logs",
							label: "Logs",
							content: <VipFreespinsLogs {...commonProps} />,
						},
						{
							id: "analytics",
							label: "Analytics",
							content: <VipFreespinsAnalytics {...commonProps} />,
						},
					]}
				/>
			</SpaceBetween>
		);
	}
}

export default VipFreespins;
